// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';

import { Flex, SvgIcon, Text } from 'Components/Base';

export default function EmptySolution(/** @type {EmptySolutionProps} */ props) {
  const { title, description, icon, ...restProps } = props;
  return (
    <Flex
      flexDirection={'column'}
      alignItems={'center'}
      justifyContent="center"
      height={'calc(100vh - 296px)'}
      {...restProps}
    >
      <SvgIcon icon={icon} mb={6} />
      <Text textStyle={'heading4'} color={'clear.clearLight'} mb={4}>
        {title}
      </Text>
      <Text textStyle={'body1'} textAlign={'center'} color={'clear.clearGrayDark'}>
        {description}
      </Text>
    </Flex>
  );
}

EmptySolution.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.func,
};

/**
 * @typedef {Object} EmptySolutionProps
 * @property {string} title
 * @property {string} description
 * @property {function} icon
 */
